
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { userAuthApi } from '../services/api';
import logo from '../assets/joffon.png'; 

const Navbar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const shouldShowAdminLink = location.pathname.startsWith('/admin');
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const checkAuthStatus = async () => {
      try {
        const response = await userAuthApi.getCurrentUser();
        if (response.data?.authenticated) {
          setIsAuthenticated(true);
          try { localStorage.setItem('currentUser', JSON.stringify(response.data.user)); } catch (e) { /* ignore */ }
        } else {
          setIsAuthenticated(false);
          try { localStorage.removeItem('currentUser'); } catch (e) { /* ignore */ }
        }
      } catch (error) {
        // Only clear auth state on an explicit server rejection (e.g. 401).
        // Network/CORS errors mean the server is unreachable — don't log the
        // user out just because the backend is temporarily unavailable.
        if (error.response) {
          setIsAuthenticated(false);
          try { localStorage.removeItem('currentUser'); } catch (e) { /* ignore */ }
        }
      }
    };
    
    checkAuthStatus();
  }, [location.pathname]); // URL වෙනස්වන හැමවිටම Auth Check එක සිදුකරයි

  const handleLogout = async () => {
    try {
      await userAuthApi.logout();
      setIsAuthenticated(false);
      try { localStorage.removeItem('currentUser'); } catch (e) { /* ignore */ }
      navigate('/login');
    } catch (error) {
    }
  };

  return (
    <nav className="sticky top-0 z-50 border-b border-cyan-400/20 bg-[#060813]/65 backdrop-blur-xl shadow-[0_8px_25px_-12px_rgba(217,70,239,0.6)]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16 items-center">
          <div className="flex-shrink-0">
            <Link to="/" className="flex items-center gap-3 group">
              <img 
                src={logo} 
                alt="JOFFON Logo" 
                className="h-8 w-auto object-contain transition-all duration-300 ease-in-out group-hover:drop-shadow-[0_0_12px_rgba(34,211,238,0.75)]"
              />
              <div className="flex flex-col leading-none">
                <span className="text-xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-cyan-300 via-fuchsia-300 to-pink-300 tracking-[0.22em] cyber-text transition-all duration-300 ease-in-out group-hover:drop-shadow-[0_0_10px_rgba(236,72,153,0.8)]">JOFFON</span>
              </div>
            </Link>
          </div>

          <div className="flex items-center gap-3">
            {shouldShowAdminLink && (
              <Link
                to="/admin/payments"
                className="inline-flex items-center rounded-full border border-fuchsia-400/40 bg-fuchsia-400/10 px-5 py-2 text-sm font-semibold uppercase tracking-[0.18em] text-fuchsia-200 transition-all duration-300 hover:border-fuchsia-300 hover:bg-fuchsia-400/20 hover:text-white"
              >
                Admin
              </Link>
            )}
            <Link
              to="/secure-payment"
              className="inline-flex items-center rounded-full border border-cyan-400/40 bg-cyan-400/10 px-5 py-2 text-sm font-semibold uppercase tracking-[0.18em] text-cyan-200 transition-all duration-300 hover:border-cyan-300 hover:bg-cyan-400/20 hover:text-white hover:shadow-[0_0_18px_rgba(34,211,238,0.35)]"
            >
              Payment
            </Link>
            {isAuthenticated ? (
              <>
                <Link
                  to="/profile"
                  className="flex items-center justify-center h-10 w-10 rounded-full border border-pink-400/40 bg-pink-400/10 text-pink-200 transition-all duration-300 hover:border-pink-300 hover:bg-pink-400/20 hover:text-white hover:shadow-[0_0_18px_rgba(236,72,153,0.35)]"
                  title="Profile"
                >
                  <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                  </svg>
                </Link>
                <button
                  onClick={handleLogout}
                  className="inline-flex items-center rounded-full border border-red-400/40 bg-red-400/10 px-5 py-2 text-sm font-semibold uppercase tracking-[0.18em] text-red-200 transition-all duration-300 hover:border-red-300 hover:bg-red-400/20 hover:text-white hover:shadow-[0_0_18px_rgba(239,68,68,0.35)]"
                >
                  Logout
                </button>
              </>
            ) : (
              <Link
                to="/login"
                className="inline-flex items-center rounded-full border border-pink-400/40 bg-pink-400/10 px-5 py-2 text-sm font-semibold uppercase tracking-[0.18em] text-pink-200 transition-all duration-300 hover:border-pink-300 hover:bg-pink-400/20 hover:text-white hover:shadow-[0_0_18px_rgba(236,72,153,0.35)]"
              >
                Login
              </Link>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;